export default "__VITE_ASSET__CtP_eKCf__"